let cached: { value: number; at: number } | null = null;
const TTL_MS = 60_000;

export async function getSolUsd(): Promise<number> {
  const now = Date.now();
  if (cached && now - cached.at < TTL_MS) return cached.value;

  try {
    const ac = new AbortController();
    const t = setTimeout(() => ac.abort(), 5000);
    const res = await fetch(
      "https://api.coinbase.com/v2/prices/SOL-USD/spot",
      { signal: ac.signal },
    );
    clearTimeout(t);
    if (!res.ok) throw new Error(String(res.status));
    const data = (await res.json()) as { data?: { amount?: string } };
    const v = parseFloat(data?.data?.amount || "0");
    if (typeof v === "number" && !isNaN(v) && v > 0) {
      cached = { value: v, at: now };
      return v;
    }
  } catch {
    /* fall through */
  }
  return cached?.value ?? 150;
}
